// Stripe appends these to return_url when stripe.confirmSetup leaves the page
// (an issuer's full-page 3DS) and sends the buyer back.
const SETUP_INTENT_PARAM = 'setup_intent';
const CLIENT_SECRET_PARAM = 'setup_intent_client_secret';
const RETURN_PARAMS = [SETUP_INTENT_PARAM, CLIENT_SECRET_PARAM, 'redirect_status'];

export interface SetupIntentReturn {
  setupIntentId: string;
  // 'succeeded' or 'failed'; null when Stripe sent none.
  redirectStatus: string | null;
  clientSecret: string | null;
}

// readSetupIntentReturn returns Stripe's SetupIntent return params, or null
// when this load is not a SetupIntent redirect return.
export function readSetupIntentReturn(search: string): SetupIntentReturn | null {
  const params = new URLSearchParams(search);
  const setupIntentId = params.get(SETUP_INTENT_PARAM);
  if (!setupIntentId) {
    return null;
  }
  return { setupIntentId, redirectStatus: params.get('redirect_status'), clientSecret: params.get(CLIENT_SECRET_PARAM) };
}

// stripSetupIntentReturn removes only Stripe's return params (the client
// secret included) from the address bar, keeping every other param and the
// hash, so a reload or a shared link never replays the return.
export function stripSetupIntentReturn(): void {
  const url = new URL(window.location.href);
  if (!RETURN_PARAMS.some((name) => url.searchParams.has(name))) {
    return;
  }
  for (const name of RETURN_PARAMS) {
    url.searchParams.delete(name);
  }
  window.history.replaceState(window.history.state, '', url.toString());
}
